import type { DiscoveredRouteModule } from '@/router/generator/types';

const AdminSettingsView = () => import('@/views/admin/SettingsView.vue');
const AdminSettingsIndexView = () => import('@/views/admin/settings/IndexView.vue');
const AdminSettingsSuccessView = () => import('@/views/admin/settings/SuccessView.vue');

export const NAME_ADMIN_SETTINGS = 'AdminSettings';
export const NAME_ADMIN_SETTINGS_INDEX = 'AdminSettingsIndex';
export const NAME_ADMIN_SETTINGS_SUCCESS = 'AdminSettingsSuccess';
export const PATH_ADMIN_SETTINGS = 'settings';

const children = [
  { path: '', component: AdminSettingsIndexView, name: NAME_ADMIN_SETTINGS_INDEX, meta: { dataLoaders: ['project_document', 'features', 'project_subscriptions', 'products_and_prices'] } },
  { path: 'success', component: AdminSettingsSuccessView, name: NAME_ADMIN_SETTINGS_SUCCESS, meta: { dataLoaders: ['project_document', 'project_subscriptions'] } },
];

export const route: DiscoveredRouteModule = {
  id: 'admin.settings',
  scope: 'admin',
  moduleKey: 'settings',
  name: NAME_ADMIN_SETTINGS,
  path: PATH_ADMIN_SETTINGS,
  component: AdminSettingsView,
  meta: { requiresAdmin: true },
  children,
};
